"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var getAddressOptions = function getAddressOptions(results) {
  var options = (0, _lodash.map)(results, function (result) {
    return {
      address: result.formatted_address,
      result: result,
      id: result.place_id,
      latLng: {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      }
    };
  });
  return options;
};
var getGeoCodeOptions = (0, _lodash.debounce)(function (address, callback, google) {
  if (address.length > 3) {
    var geoCoder = new google.maps.Geocoder();
    geoCoder.geocode({
      address: address
    }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK || status === google.maps.GeocoderStatus.ZERO_RESULTS) {
        var options = getAddressOptions(results);
        callback(options);
      } else {
        /* eslint-disable-next-line no-console */
        console.warn("Geocode was not successful for the following reason: ".concat(status));
      }
    });
  } else {
    callback([]);
  }
}, 400);
var _default = exports["default"] = getGeoCodeOptions;